import { useMutation } from "@tanstack/react-query";
import { signup as signupApi } from "../../services/apiAuth";
import { toast } from "react-hot-toast";

export function useSignup() {
  const { mutate: signup, isLoading } = useMutation({
    mutationFn: signupApi,
    onSuccess: (user) => {
      toast.success(
        "Administrador criado com sucesso! Por favor confirme sua nova conta a partir no endereço do email do usuário"
      );
    },
  });

  return { signup, isLoading };
}